<template>
  <section class="add_recipt card_style">
    <div class="main_header_style">
      <h4>{{ $t("edit_exchange") }}</h4>
    </div>
    <form class="form_topic" @submit.prevent="editExchange()">
      <div class="row">
        <!-- start input group -->
        <div class="col-12 col-lg-12">
          <div class="input-group">
            <label class="form-label"> {{ $t("statement") }}</label>
            <textarea
              class="form-control"
              :placeholder="$t('add_statement')"
              v-model="report"
            ></textarea>
          </div>
        </div>
        <!-- finish input group -->

        <!-- start input group -->
        <div class="col-12">
          <button type="submit" class="btn PrimaryButton w-25">
            {{ $t("edit") }}
          </button>
        </div>
        <!-- finish input group -->
      </div>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "add-recipt",
  components: {},
  data() {
    return {
      report: "",
    };
  },
  methods: {
    // fetch exchange
    fetchexchangeData() {
      let id = this.$route.params.id;
      // console.log(id);
      axios.get("/exchange_bill/" + id).then(({ data }) => {
        this.report = data.data.report;
      });
    },
    async editExchange() {
      let id = this.$route.params.id;
      const params = new URLSearchParams();
      params.append("report", this.report);

      axios
        .put(`/exchange_bill/${id}`, params)

        .then((response) => {
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "success",
          });
          this.$router.push("/exchange");
        })
        .catch((error) => {
          Swal.fire({
            title: "",
            text: error.response.data.message,
            icon: "error",
          });
        });
    },
  },
  created() {
    this.fetchexchangeData();
    localStorage.removeItem("flightData");
    localStorage.removeItem("flightTrips");
    localStorage.removeItem("bookDataFlight");
    localStorage.removeItem("bookDetails");
    localStorage.removeItem("hotelData");
    localStorage.removeItem("bookData");
  },
};
</script>

<style lang="scss" scoped>
@import "./_exchange.scss";
</style>
